import './GaugePointer.scss';
import React from 'react';
import GaugeChart from 'react-gauge-chart'

const GaugePointer = ({ value, currentTheme }) => {
    // Convert the value to a percentage (0 to 1 scale) as required by GaugeChart
    const percent = value / 100;

    const formatTextValue = (value) => {
        return `${value}%`;
    };

    return (
        <div className="gauge-pointer">
            <div className="gauge-pointer-title">CLAIM AWARENESS METER</div>
            <GaugeChart
                id="gauge-chart4"
                style={{ height: 120 }}
                nrOfLevels={10}
                arcPadding={0.1}
                cornerRadius={3}
                percent={percent}
                textColor={currentTheme === "dark" ? "#fff" : "#000"}
                formatTextValue={formatTextValue}
            />
            <div className="gauge-pointer-footer">This scale measures the probability of a fradulent claim. It takes into account various paramreters to calculate the score. Please note that this gauge does not flag the claim as fradulent but rather raises your awarenes to look keenly into it</div>
        </div>
    );
};

export default GaugePointer;
